// extracted by mini-css-extract-plugin
module.exports = {"main":"layouts_main__22a8t","main_wrapper":"layouts_main_wrapper__3SJHM","logo":"layouts_logo__15tu3"};